<template>
  <div
    class="co-arrow-down"
    :style="[arrowWidth, arrowBorderTopWidth, arrowBorderTopColor, arrowBorderRightWidth, arrowBorderLeftWidth]"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent ({
  props: {
    width: {
      type: String,
      default: '100',
      required: false,
    },
    borderTopColor: {
      type: String,
      default: '#ccc',
      required: false,
    },
    borderTopWidth: {
      type: String,
      default: '25',
      required: false,
    },
    borderRightWidth: {
      type: String,
      default: '50',
      required: false,
    },
    borderLeftWidth: {
      type: String,
      default: '50',
      required: false,
    },
  },
  computed: {
    arrowWidth() {
      return {
        '--width': this.width + 'px',
      }
    },
    arrowBorderTopWidth() {
      return {
        '--border-top-width': this.borderTopWidth + 'px',
      }
    },
    arrowBorderTopColor() {
      return {
        '--border-top-color': this.borderTopColor,
      }
    },
    arrowBorderRightWidth() {
      return {
        '--border-right-width': this.borderRightWidth + 'px',
      }
    },
    arrowBorderLeftWidth() {
      return {
        '--border-left-width': this.borderLeftWidth + 'px',
      }
    },
  },
})
</script>

<style scoped>
.co-arrow-down {
  width: var(--width);
  content: '';
  border-top: var(--border-top-width) solid var(--border-top-color, #ccc);
  border-right: var(--border-right-width) solid transparent;
  border-left: var(--border-left-width) solid transparent;
}
</style>
